<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('promotion.pageTitle') }}</h1>
      <ts-breadcrumb :items="[
        { text: $t('home'), href: '/' },
        {
          text: $t('promotion.pageTitle'),
          href: '/admin/promotions',
        },
        {
          text: $t('edit'),
          active: true,
        },
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <a-tabs default-active-key="6">
            <a-tab-pane key="6" :tab="$t('promotion.discountByRange')">
              <DiscountByRangeForm ref="discountByRangeForm" />
            </a-tab-pane>
          </a-tabs>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import DiscountByRangeForm from './components/discount-by-range-form'

export default {
  name: 'discountByRangeEdit',
  components: {
    DiscountByRangeForm
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    ...mapActions('promotion/discountByRange', ['update', 'find']),
    ...mapActions('promotion/resource', ['getBranch', 'getSaleCode']),
    async fetchData() {
      this.loading = true
      await this.getBranch()
      await this.getSaleCode()
      await this.setEditData()
      this.loading = false
    },
    async setEditData() {
      await this.find(this.$route.params.id)
        .then(() => {
          this.$refs.discountByRangeForm.setEditData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
    },
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('promotion/discountByRange/SET_EDIT_DATA', {})
    this.$store.commit('promotion/resource/CLEAR_SETUP')
    next()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>

<style></style>